var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.tableData,
            "element-loading-text": "Loading...",
            "row-key": _vm.rowKeyHandler,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "NickName",
              label: "Nick Name",
              "min-width": "150",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ScanDate",
              label: "Scanned Date",
              "min-width": "150",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "Follow", "min-width": "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.tagTypeParser(!row.Deleted),
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.tagLabelParser(!row.Deleted)) + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "AcceptedTerms",
              label: "Accepted Terms",
              "min-width": "200",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.tagTypeParser(row.AcceptedTerms),
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.tagLabelParser(row.AcceptedTerms)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "AcceptedNewTerms",
              label: "Accepted New Terms",
              "min-width": "200",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.tagTypeParserForAcceptedNewTerms(
                            row.AcceptedNewTerms
                          ),
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.tagLabelParserForAcceptedNewTerms(
                                row.AcceptedNewTerms
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Certified", "min-width": "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.tagTypeParser(
                            row.AcceptedTerms && row.Active
                          ),
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.tagLabelParser(
                                row.AcceptedTerms && row.Active
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Operation", "min-width": "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          icon: "el-icon-delete",
                          size: "medium",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v(" Delete ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }